/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const r = "invalidMaxFileSize", t = "invalidMinFileSize", e = "invalidFileExtension", E = (i, n) => {
  n.length > 0 && n.indexOf((i.extension || "").toLowerCase()) < 0 && (i.validationErrors = i.validationErrors || [], i.validationErrors.indexOf(e) < 0 && i.validationErrors.push(e));
}, l = (i, n, o) => {
  n !== 0 && (i.size || 0) < n && (i.validationErrors = i.validationErrors || [], i.validationErrors.indexOf(t) < 0 && i.validationErrors.push(t)), o !== 0 && (i.size || 0) > o && (i.validationErrors = i.validationErrors || [], i.validationErrors.indexOf(r) < 0 && i.validationErrors.push(r));
}, v = (i) => i.map((o) => (o.substring(0, 1) === "." ? o : "." + o).toLowerCase()), x = (i, n) => {
  const o = v(n.allowedExtensions || []), s = n.maxFileSize || 0, d = n.minFileSize || 0;
  let a;
  for (a = 0; a < i.length; a++)
    E(i[a], o), l(i[a], d, s);
}, c = {
  validateFiles: x
};
export {
  c as default
};
